exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageLayout_root_3OhxF {\n  background-color: white;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.PageLayout_title_GvkaF {\n  padding: 60px 24px 25px;\n  font-size: 21px;\n  flex: 0 1 auto;\n  z-index: 2;\n  transition: all 0.3s ease;\n}\n\n.PageLayout_title_GvkaF.PageLayout_overflow_3Zb2- {\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px;\n}\n\n.PageLayout_content_2mZ6H {\n  height: 100%;\n  overflow: auto;\n  flex: 1 1 auto;\n  z-index: 1;\n}\n\n@media (max-height: 530px) {\n  .PageLayout_title_GvkaF {\n    padding-top: 16px;\n    padding-bottom: 16px;\n    padding-left: 58px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"root": "PageLayout_root_3OhxF",
	"title": "PageLayout_title_GvkaF",
	"overflow": "PageLayout_overflow_3Zb2-",
	"content": "PageLayout_content_2mZ6H"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/PageLayout/PageLayout.css
// module id = 1211
// module chunks = 2